import { motion, AnimatePresence } from 'framer-motion';
import { X, Download, Share } from 'lucide-react';
import { assets } from '../../data/events';

export const PWAInstallPrompt = ({ show, onInstall, onDismiss, isIOS }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="pwa-install-prompt"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-24 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-96 z-50"
        >
          <div className="bg-black rounded-2xl p-5 shadow-2xl border border-gray-800">
            {/* Close button */}
            <button
              onClick={onDismiss}
              className="absolute top-3 right-3 p-1.5 rounded-full hover:bg-white/10 transition-colors"
              data-testid="pwa-dismiss-btn"
            >
              <X className="w-4 h-4 text-gray-400" />
            </button>

            <div className="flex items-start gap-4">
              {/* App icon */}
              <div className="flex-shrink-0 w-14 h-14 rounded-xl overflow-hidden bg-white/10 flex items-center justify-center">
                <img 
                  src={assets.logo} 
                  alt="L'Atelier by JS" 
                  className="w-12 h-12 object-contain"
                />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <h3 className="font-league text-lg uppercase tracking-wide text-white">
                  Installer l'app
                </h3>
                <p className="font-dm text-xs text-gray-400 mt-1 leading-relaxed">
                  Accédez rapidement au calendrier du food truck depuis votre écran d'accueil
                </p>
              </div>
            </div>

            {/* Action */}
            <div className="mt-4">
              {isIOS ? (
                <div className="flex items-center gap-2 bg-white/5 rounded-xl p-3">
                  <Share className="w-5 h-5 text-[#97c7c3] flex-shrink-0" />
                  <p className="font-dm text-xs text-gray-300">
                    Appuyez sur <span className="text-white font-medium">Partager</span> puis <span className="text-white font-medium">Sur l'écran d'accueil</span>
                  </p>
                </div>
              ) : (
                <button
                  onClick={onInstall}
                  className="w-full flex items-center justify-center gap-2 py-3 bg-[#97c7c3] text-black rounded-xl font-dm text-sm font-bold transition-all hover:bg-[#7dbbb6] active:scale-[0.98]"
                  data-testid="pwa-install-btn"
                >
                  <Download className="w-4 h-4" />
                  Installer
                </button>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
